import {initPercentileForm} from "./percentileForm";

function setupCollapsibleSection(elementTitle, elementSection, onChange, isOpenByDefault) {
    const elementTitleNode = document.getElementById(elementTitle);
    const elementSelectionNode = document.getElementById(elementSection);
    if (!elementTitleNode || !elementSelectionNode) {
        return;
    }

    let isOpen = isOpenByDefault || false;

    function setOpen(open) {
        elementTitleNode.classList.toggle("collapsible__title--closed", !open);
        elementSelectionNode.classList.toggle("collapsible--closed", !open);
    }

    elementTitleNode.classList.add("collapsible__title");
    setOpen(isOpen);

    elementTitleNode.addEventListener("click", function () {
        const isOpening = elementSelectionNode.classList.contains("collapsible--closed");
        isOpen = isOpening;
        setOpen(isOpen);
        if (onChange) {
            onChange(isOpen);
        }
    });
}

initPercentileForm(window.strengthLevelPercentileForm || {});

function initAfterDocument() {
    setupCollapsibleSection("explanationTitle", "explanationSection", function (isOpen) {
        if (isOpen && typeof window.gtag === "function") {
            window.gtag("event", "explain", {"event_category": "lift"});
        }
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAfterDocument);
} else {
    initAfterDocument();
}
